module.exports = __webpack_public_path__ + "img/beijing14.0a0eca66.jpg";